import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "@iventis/subscriptions";
import "@iventis/styles/src/font-awesome";
import { Body1, Body2, Header4, InteractiveElement, passwordContentMargin, passwordHeaderMargin, styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { IventisFooter, SiteLogoComponent } from "@iventis/components";
import { LoginPanelContainer, LoginPageContainer } from "@iventis/components/src/login-containers";
import { LoginBackground } from "./login";

export const ForgottenPasswordConfirmationComponent: FunctionComponent = () => {
    const translate = useIventisTranslate();
    const history = useHistory();
    return (
        <LoginBackground>
            <LoginPageContainer>
                <LoginPanelContainer>
                    <SiteLogoComponent />
                    <EmailConfirmation />
                    <Body1 style={{ marginTop: "2%", marginRight: "2%", marginBottom: "2%" }}>{translate(Content.login.subHeadings.confirmation)}</Body1>
                    <Body2 style={{ marginTop: "5%", marginRight: passwordContentMargin }}>
                        {translate(Content.login.options.notReceived)}
                        <StyledForgottenPasswordResendEmail onClick={() => history.push("/forgotten-password")}>
                            &nbsp;{translate(Content.login.links.sendAgain)}
                        </StyledForgottenPasswordResendEmail>
                    </Body2>
                </LoginPanelContainer>
                <IventisFooter />
            </LoginPageContainer>
        </LoginBackground>
    );
};

const EmailConfirmation = () => {
    const translate = useIventisTranslate();
    return (
        <StyledEmailConfirmation className="email-confirmation">
            <FontAwesomeIcon
                className="check-mark-circle"
                data-testid="check-mark-circle"
                icon={["fas", "circle-check"]}
                style={{ height: "18px", width: "18px", color: "#27cca3" }}
            />
            <Header4>{translate(Content.login.headings.confirmation)}</Header4>
        </StyledEmailConfirmation>
    );
};

const StyledEmailConfirmation = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: ${passwordHeaderMargin};

    .check-mark-circle {
        margin: 3px 8px 3px 0px;
    }
`;

const StyledForgottenPasswordResendEmail = styled(InteractiveElement)`
    cursor: pointer;
    text-decoration: underline;
`;

export default ForgottenPasswordConfirmationComponent;
